import { render } from "./ScrapingDetail2.vue?vue&type=template&id=601d850e"
import script from "./ScrapingDetail2.vue?vue&type=script&lang=js"
export * from "./ScrapingDetail2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__